import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import VertNav from "../VertNav";
import config from "../../../config";
import {
    FaTimes,
    FaTrash,
    FaSearch,
    FaUserAlt,
    FaClipboardList,
    FaQuestionCircle,
    FaRegCommentDots,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";

const InputField = React.forwardRef(
    (
        {
            label,
            type = "text",
            value,
            onChange,
            placeholder,
            required = false,
            ...props
        },
        ref
    ) => (
        <div className="flex flex-col space-y-1">
            {label && (
                <label className="text-sm font-medium text-gray-700">
                    {label}
                </label>
            )}
            <input
                ref={ref}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition placeholder-gray-900"
                {...props}
            />
        </div>
    )
);

const NewInquiry = () => {
    const [customerName, setCustomerName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [comments, setComments] = useState("");
    const [services, setServices] = useState([]);
    const [inquiry, setInquiry] = useState([]);
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    const [categoryServices, setCategoryServices] = useState([]);
    const [hasFetchedServicesCategory, setHasFetchedServicesCategory] =
        useState(false);
    const [hasFetchedProducts, setHasFetchedProducts] = useState(false);
    const [isServiceModalOpen, setServiceModalOpen] = useState(false);
    const [isProductModalOpen, setProductModalOpen] = useState(false);
    const [selectedServiceValues, setSelectedServiceValues] = useState([]);
    const [productData, setProductData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [genderFilter, setGenderFilter] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [selectedList2, setSelectedList2] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [customerData, setCustomerData] = useState(null);
    const [customerId, setCustomerId] = useState("");
    const [userExists, setUserExists] = useState(false);
    const navigate = useNavigate();
    const sname = localStorage.getItem("sname");
    const branchName = localStorage.getItem("branch_name");
    const bid = localStorage.getItem("branch_id");
    const mobileInputRef = useRef(null);
    const nameInputRef = useRef(null);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
        }).format(amount);
    };

    const StatsCard = ({ title, value }) => (
        <div className="bg-white p-6 rounded-2xl flex flex-col items-center justify-center">
            <h3 className="text-gray-500 text-sm font-medium">{title}</h3>
            <p className="text-2xl font-bold text-blue-600 mt-2">{value}</p>
        </div>
    );

const fetchServiceCategoryData = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            `${config.apiUrl}/api/swalook/table/services/?branch_name=${bid}`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to fetch categories: ${response.statusText}`
            );
        }

        const result = await response.json();

        if (!result.status || !Array.isArray(result.data)) {
            throw new Error("Invalid API response format");
        }

        // Transform API response into a structured category-service map
        const categoryMap = new Map();

        result.data.forEach((categoryData) => {
            const categoryName = categoryData.category_name || "Uncategorized";

            // If the category doesn't exist yet, create an entry for it
            if (!categoryMap.has(categoryName)) {
                categoryMap.set(categoryName, {
                    key: categoryName,
                    value: categoryName,
                    services: [],
                });
            }

            const category = categoryMap.get(categoryName);

            // Process regular services
            if (categoryData.services && Array.isArray(categoryData.services)) {
                categoryData.services.forEach((service) => {
                    category.services.push({
                        id: service.id,
                        name: service.service || "Unnamed Service",
                        price: service.service_price || 0,
                        duration: service.service_duration || 0,
                        for_men: service.for_men,
                        for_women: service.for_women,
                        quantity: 1,
                        staff: [],
                        note: "No notes added",
                        category: categoryName,
                        type: "service"
                    });
                });
            }

            // Process combos - treat them as services for display purposes
            if (categoryData.combos && Array.isArray(categoryData.combos)) {
                categoryData.combos.forEach((combo) => {
                    category.services.push({
                        id: `combo-${combo.combo_name}`,
                        name: `${combo.combo_name} (Combo)`,
                        price: combo.combo_price || 0,
                        duration: combo.duration || 0,
                        for_men: true, // Combos typically available for both
                        for_women: true,
                        quantity: 1,
                        staff: [],
                        note: "No notes added",
                        category: categoryName,
                        type: "combo",
                        isCombo: true,
                        comboData: combo // Store original combo data for reference
                    });
                });
            }
        });

        // Convert the categoryMap to an array
        const categories = Array.from(categoryMap.values());

        // Log the structured categories for debugging
        console.log("Structured categories:", categories);

        setCategoryServices(categories);
        setHasFetchedServicesCategory(true);
    } catch (error) {
        console.error("Error fetching categories:", error.message);
    }
};

    const fetchData = async () => {
        try {
            const branchName = localStorage.getItem("branch_name");
            const token = localStorage.getItem("token");

            if (!branchName || !token) {
                console.error("Branch name or token is missing.");
                return;
            }

            const response = await fetch(
                `${config.apiUrl}/api/swalook/inventory/product/?branch_name=${bid}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch products: ${response.statusText}`
                );
            }

            const result = await response.json();

            if (!result.status || !Array.isArray(result.data)) {
                throw new Error("Invalid API response format");
            }

            const categoryMap = new Map();

            result.data.forEach((product) => {
                const categoryName =
                    product.category_details?.product_category ||
                    "Uncategorized";

                if (!categoryMap.has(categoryName)) {
                    categoryMap.set(categoryName, {
                        key: categoryName,
                        value: categoryName,
                        products: [],
                    });
                }

                categoryMap.get(categoryName).products.push({
                    id: product.id,
                    name: product.product_name || "Unnamed Product",
                    price: product.product_price || 0,
                    quantity: 1,
                    staff: [],
                    note: "No notes added",
                    category: categoryName,
                });
            });

            const categories = Array.from(categoryMap.values());
            setProductCategory(categories);
            setHasFetchedProducts(true);
        } catch (error) {
            console.error("Error fetching products:", error.message);
        }
    };

    const handleGenderFilterToggle = (gender, isChecked) => {
        setGenderFilter((prevFilter) =>
            isChecked
                ? [...prevFilter, gender]
                : prevFilter.filter((g) => g !== gender)
        );
    };

    const filteredCategories = categoryServices.filter(
        (category) =>
            category.value?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            category.services.some((service) =>
                service.name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
    );

    const filteredproduct = productCategory.filter(
        (category) =>
            category.value?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            category.products.some((product) =>
                product.name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
    );

    const finalizeSelection = () => {
        setServices(selectedList);
        setProductData(selectedList2);
        console.log("Selected Services:", selectedList);
        console.log("Selected Products:", selectedList2);
    };

    const toggleServiceSelection = (service) => {
        if (selectedList.some((s) => s.id === service.id))
            handleServiceSelect(
                selectedList.filter((s) => s.id !== service.id)
            );
        else handleServiceSelect([...selectedList, service]);
    };

    const handleServiceSelect = (selected) => {
        setSelectedServiceValues(selected);
        const updatedServiceList = selected.map((service) => ({
            ...service,
            staff: service.staff || [],
            note: service.note || "No notes added",
            category: service.category,
        }));
        setSelectedList(updatedServiceList);
    };

    const toggleProductSelection = (product) => {
        setSelectedList2((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (p) => p.id === product.id
            );
            return isAlreadySelected
                ? prevSelected.filter((p) => p.id !== product.id)
                : [...prevSelected, product];
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await addCustomer();
        const token = localStorage.getItem("token");
        if (!token) {
            alert("User not authenticated");
            return;
        }
        try {
            const response = await fetch(
                `${config.apiUrl}/api/swalook/enquery/?branch_name=${bid}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                    body: JSON.stringify({
                        customer_name: customerName,
                        mobile_no: mobileNo,
                        comment: comments,
                        query_for: {
                            service: selectedList.map((s) => s.name).join(", "),
                            product: selectedList2
                                .map((p) => p.name)
                                .join(", "),
                        },
                    }),
                }
            );
            if (!response.ok)
                throw new Error(
                    `Failed to create inquiry: ${response.statusText}`
                );
            toast.success("Inquiry created successfully!");
        } catch (error) {
            console.error("Error creating inquiry:", error.message);
        }
    };

    const addCustomer = async () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch_id");

        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${branchId}`,
                {
                    name: customerName,
                    mobile_no: mobileNo,
                    email: " ",
                    membership: "",
                    d_o_b: "",
                    d_o_a: "",
                    coupon: [],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            const { status, data } = response;
            console.log("API Response:", data);

            if (status >= 200 && status < 300 && data.success) {
                return true;
            } else {
                throw new Error(data.message || "Failed to add customer.");
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "An error occurred.";
            console.error("Error:", error.response?.data || error.message);
            return false;
        }
    };

    const fetchCustomerData = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get-customer-bill-app-data/?mobile_no=${mobileNo}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setCustomerId(response.data);
            console.log("Fetched data:", response.data);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const handlePhoneBlur = async () => {
        try {
            const branchName = localStorage.getItem("branch_id");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/loyality_program/customer/?branch_name=${branchName}`,
                {
                    headers: {
                        Authorization: `Token ${localStorage.getItem("token")}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                const userDetailsResponse = await axios.get(
                    `${config.apiUrl}/api/swalook/loyality_program/customer/get_details/?branch_name=${branchName}&mobile_no=${mobileNo}`,
                    {
                        headers: {
                            Authorization: `Token ${localStorage.getItem(
                                "token"
                            )}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const userDataArray = userDetailsResponse.data.data;
                if (Array.isArray(userDataArray) && userDataArray.length > 0) {
                    const userData = userDataArray[0];
                    setUserExists(true);
                    setCustomerName(userData.name || "");
                    setCustomerData(userData);
                }
            } else {
                setUserExists(false);
            }
        } catch (error) {
            console.error("Error checking membership status:", error);
        }
    };

    useEffect(() => {
        if (mobileNo.length === 10) {
            const timeoutId = setTimeout(() => {
                fetchCustomerData();
            }, 500);

            return () => clearTimeout(timeoutId);
        }
    }, [mobileNo]);

    useEffect(() => {
        if (mobileNo.length === 10) {
            handlePhoneBlur();
        }
    }, [mobileNo]);
    // Handle view details click
    const handleViewDetailsClick = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get-customer-bill-app-data/?mobile_no=${mobileNo}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setCustomerData(response.data);
            console.log("User data:", response.data);

            setIsPopupVisible(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Handle close popup

    const handleClosePopup = () => {
        window.location.reload();
    };

    const handleAllInquires = (id) => {
        navigate(`/${sname}/${branchName}/inquiries`);
    };

    return (
        <div className="bg-gray-100 min-h-full">
            <Header />
            <VertNav />
            <ToastContainer />
            <div className=" md:ml-72 p-4 md:p-8">
                <form onSubmit={handleSubmit} className="max-w-screen mx-auto">
                    <div className="bg-white shadow-xl rounded-3xl p-6">
                        {/* Customer Stats Section */}
                        {userExists && customerId && (
                            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-8">
                                <StatsCard
                                    title="Business"
                                    value={formatCurrency(
                                        customerId.total_billing_amount
                                    ).replace("₹", "Rs. ")}
                                />
                                <StatsCard
                                    title="Appointments"
                                    value={customerId.total_appointment}
                                />
                                <StatsCard
                                    title="Invoices"
                                    value={customerId.total_invoices}
                                />
                                <div className="bg-white p-6 rounded-2xl flex items-center justify-center">
                                    <button
                                        type="button"
                                        onClick={handleViewDetailsClick}
                                        className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
                                    >
                                        View Details{" "}
                                        <span className="ml-2">→</span>
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                                <FaClipboardList
                                    className="mr-3 text-blue-500"
                                    aria-hidden="true"
                                />
                                New Inquiry
                            </h2>
                            <button
                                type="button"
                                onClick={handleAllInquires}
                                className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
                            >
                                View All Inquires{" "}
                                <span className="ml-2">→</span>
                            </button>
                        </div>

                        {/* Customer Details */}
                        <div className="mb-6 bg-gray-50 p-4 rounded-xl">
                            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                <FaUserAlt className="mr-2 text-blue-500" />
                                Customer Details
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <InputField
                                    label="Phone Number"
                                    type="tel"
                                    ref={mobileInputRef}
                                    value={mobileNo}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(
                                            /\D/g,
                                            ""
                                        );
                                        if (value.length <= 10) {
                                            setMobileNo(value);
                                            if (value.length === 10) {
                                                nameInputRef.current?.focus();
                                            }
                                        }
                                    }}
                                    placeholder="Enter 10-digit mobile number"
                                    required
                                />
                                <InputField
                                    label="Full Name"
                                    type="text"
                                    ref={nameInputRef}
                                    value={customerName}
                                    onChange={(e) =>
                                        setCustomerName(e.target.value)
                                    }
                                    placeholder="Customer full name"
                                    required
                                />
                            </div>
                        </div>

                        {/* Inquired About Section */}
                        <div className="mb-6 bg-gray-50 p-4 rounded-xl">
                            <h3 className="font-semibold text-lg text-gray-700 mb-4 flex items-center">
                                <FaQuestionCircle
                                    className="mr-2 text-blue-400"
                                    aria-hidden="true"
                                />
                                Inquired About:
                            </h3>
                            <div className="flex flex-wrap gap-3">
                                <button
                                    type="button"
                                    className="px-5 py-2 bg-white border border-blue-500 text-blue-500 font-medium rounded-full hover:bg-blue-50 transition-colors"
                                    onClick={() => {
                                        setServiceModalOpen(true);
                                        fetchServiceCategoryData();
                                    }}
                                >
                                    Add Services
                                </button>
                                <button
                                    type="button"
                                    className="px-5 py-2 bg-white border border-blue-500 text-blue-500 font-medium rounded-full hover:bg-blue-50 transition-colors"
                                    onClick={async () => {
                                        await fetchData();
                                        setProductModalOpen(true);
                                    }}
                                >
                                    Add Products
                                </button>
                            </div>
                        </div>

                        {/* Selected Services Table */}
                        {selectedList.length > 0 && (
                            <div className="mb-6 bg-gray-50 p-4 rounded-xl">
                                <h3 className="font-semibold text-lg text-gray-700 mb-4">
                                    Selected Services
                                </h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-100">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    S/N
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Service
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Price
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Category
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {selectedList.map(
                                                (service, index) => (
                                                    <tr key={service.id}>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            {index + 1}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                            {service.name}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                                            ₹{service.price}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            {service.category}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            <button
                                                                onClick={() =>
                                                                    toggleServiceSelection(
                                                                        service
                                                                    )
                                                                }
                                                                className="text-red-500 hover:text-red-700 p-1"
                                                            >
                                                                <FaTrash
                                                                    size={16}
                                                                />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Selected Products Table */}
                        {selectedList2.length > 0 && (
                            <div className="mb-6 bg-gray-50 p-4 rounded-xl">
                                <h3 className="font-semibold text-lg text-gray-700 mb-4">
                                    Selected Products
                                </h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-100">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    S/N
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Product
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Price
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Category
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {selectedList2.map(
                                                (product, index) => (
                                                    <tr key={product.id}>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            {index + 1}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                            {product.name}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                                            ₹{product.price}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            {product.category}
                                                        </td>
                                                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                            <button
                                                                onClick={() =>
                                                                    toggleProductSelection(
                                                                        product
                                                                    )
                                                                }
                                                                className="text-red-500 hover:text-red-700 p-1"
                                                            >
                                                                <FaTrash
                                                                    size={16}
                                                                />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Comments Section */}
                        <div className="mb-6 bg-gray-50 p-4 rounded-xl">
                            <h3 className="font-semibold text-lg text-gray-700 mb-4 flex items-center">
                                <FaRegCommentDots
                                    className="mr-2 text-blue-400"
                                    aria-hidden="true"
                                />
                                Comments:
                            </h3>
                            <textarea
                                placeholder="Enter any additional comments..."
                                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition min-h-[100px]"
                                value={comments}
                                onChange={(e) => setComments(e.target.value)}
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="flex justify-center mt-8">
                            <button
                                type="submit"
                                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-medium transition-colors shadow-md"
                            >
                                Create Inquiry
                            </button>
                        </div>
                    </div>

                    {/* Service Selection Modal */}
                    {isServiceModalOpen && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                                {/* Modal Header */}
                                <div className="flex justify-between items-center border-b p-4">
                                    <h3 className="text-xl font-bold text-gray-800">
                                        Select Services
                                    </h3>
                                    <button
                                        onClick={() =>
                                            setServiceModalOpen(false)
                                        }
                                        className="text-gray-500 hover:text-gray-700 p-1"
                                    >
                                        <FaTimes size={24} />
                                    </button>
                                </div>

                                {/* Modal Content */}
                                <div className="p-4 overflow-y-auto flex-grow">
                                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                                        <div className="relative w-full">
                                            <FaSearch className="absolute left-3 top-3 text-gray-400" />
                                            <input
                                                type="text"
                                                placeholder="Search services..."
                                                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                value={searchQuery}
                                                onChange={(e) =>
                                                    setSearchQuery(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>

                                        <div className="flex items-center space-x-4">
                                            {["Male", "Female"].map(
                                                (gender) => (
                                                    <label
                                                        key={gender}
                                                        className="flex items-center space-x-2"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={genderFilter.includes(
                                                                gender
                                                            )}
                                                            onChange={(e) =>
                                                                handleGenderFilterToggle(
                                                                    gender,
                                                                    e.target
                                                                        .checked
                                                                )
                                                            }
                                                            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                        />
                                                        <span className="text-sm text-gray-700">
                                                            {gender}
                                                        </span>
                                                    </label>
                                                )
                                            )}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {filteredCategories.map((category) => (
                                            <div
                                                key={category.key}
                                                className="border border-gray-200 rounded-lg overflow-hidden"
                                            >
                                                <div className="bg-blue-50 px-4 py-3 border-b">
                                                    <h4 className="font-semibold text-blue-800">
                                                        {category.value}
                                                    </h4>
                                                </div>
                                                <ul className="divide-y divide-gray-200">
                                                    {category.services
                                                        .filter((service) => {
                                                            if (
                                                                genderFilter.length ===
                                                                0
                                                            )
                                                                return true;
                                                            if (
                                                                genderFilter.includes(
                                                                    "Male"
                                                                ) &&
                                                                genderFilter.includes(
                                                                    "Female"
                                                                )
                                                            ) {
                                                                return true;
                                                            } else if (
                                                                genderFilter.includes(
                                                                    "Male"
                                                                )
                                                            ) {
                                                                return service.for_men;
                                                            } else if (
                                                                genderFilter.includes(
                                                                    "Female"
                                                                )
                                                            ) {
                                                                return service.for_women;
                                                            }
                                                            return false;
                                                        })
                                                        .map((service) => (
                                                            <li
                                                                key={service.id}
                                                                className="px-4 py-3 hover:bg-gray-50"
                                                            >
                                                                <div className="flex items-center justify-between">
                                                                    <label className="flex items-center space-x-3 cursor-pointer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedList.some(
                                                                                (
                                                                                    s
                                                                                ) =>
                                                                                    s.id ===
                                                                                    service.id
                                                                            )}
                                                                            onChange={() =>
                                                                                toggleServiceSelection(
                                                                                    service
                                                                                )
                                                                            }
                                                                            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                        />
                                                                        <span className="text-sm font-medium text-gray-700">
                                                                            {
                                                                                service.name
                                                                            }
                                                                        </span>
                                                                    </label>
                                                                    <span className="text-sm font-semibold text-gray-700">
                                                                        ₹
                                                                        {
                                                                            service.price
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Modal Footer */}
                                <div className="border-t p-4 bg-gray-50">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <p className="text-sm text-gray-600">
                                                Selected:{" "}
                                                <span className="font-medium">
                                                    {selectedList.length}{" "}
                                                    services
                                                </span>
                                            </p>
                                            {selectedList.length > 0 && (
                                                <p className="text-xs text-gray-500 mt-1 truncate max-w-xs">
                                                    {selectedList
                                                        .map((s) => s.name)
                                                        .join(", ")}
                                                </p>
                                            )}
                                        </div>
                                        <button
                                            onClick={() => {
                                                finalizeSelection();
                                                setServiceModalOpen(false);
                                            }}
                                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium"
                                        >
                                            Add Services
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Product Selection Modal */}
                    {isProductModalOpen && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                                {/* Modal Header */}
                                <div className="flex justify-between items-center border-b p-4">
                                    <h3 className="text-xl font-bold text-gray-800">
                                        Select Products
                                    </h3>
                                    <button
                                        onClick={() =>
                                            setProductModalOpen(false)
                                        }
                                        className="text-gray-500 hover:text-gray-700 p-1"
                                    >
                                        <FaTimes size={24} />
                                    </button>
                                </div>

                                {/* Modal Content */}
                                <div className="p-4 overflow-y-auto flex-grow">
                                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                                        <div className="relative w-full">
                                            <FaSearch className="absolute left-3 top-3 text-gray-400" />
                                            <input
                                                type="text"
                                                placeholder="Search products..."
                                                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                value={searchQuery}
                                                onChange={(e) =>
                                                    setSearchQuery(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>

                                    {filteredproduct.length === 0 ? (
                                        <p className="text-center text-gray-500 py-8">
                                            No products available
                                        </p>
                                    ) : (
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {filteredproduct.map((category) => (
                                                <div
                                                    key={category.key}
                                                    className="border border-gray-200 rounded-lg overflow-hidden"
                                                >
                                                    <div className="bg-blue-50 px-4 py-3 border-b">
                                                        <h4 className="font-semibold text-blue-800">
                                                            {category.value}
                                                        </h4>
                                                    </div>
                                                    <ul className="divide-y divide-gray-200">
                                                        {category.products.map(
                                                            (product) => (
                                                                <li
                                                                    key={
                                                                        product.id
                                                                    }
                                                                    className="px-4 py-3 hover:bg-gray-50"
                                                                >
                                                                    <div className="flex items-center justify-between">
                                                                        <label className="flex items-center space-x-3 cursor-pointer">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedList2.some(
                                                                                    (
                                                                                        p
                                                                                    ) =>
                                                                                        p.id ===
                                                                                        product.id
                                                                                )}
                                                                                onChange={() =>
                                                                                    toggleProductSelection(
                                                                                        product
                                                                                    )
                                                                                }
                                                                                className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                                                            />
                                                                            <span className="text-sm font-medium text-gray-700">
                                                                                {
                                                                                    product.name
                                                                                }
                                                                            </span>
                                                                        </label>
                                                                        <span className="text-sm font-semibold text-gray-700">
                                                                            ₹
                                                                            {
                                                                                product.price
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                </li>
                                                            )
                                                        )}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Modal Footer */}
                                <div className="border-t p-4 bg-gray-50">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <p className="text-sm text-gray-600">
                                                Selected:{" "}
                                                <span className="font-medium">
                                                    {selectedList2.length}{" "}
                                                    products
                                                </span>
                                            </p>
                                            {selectedList2.length > 0 && (
                                                <p className="text-xs text-gray-500 mt-1 truncate max-w-xs">
                                                    {selectedList2
                                                        .map((p) => p.name)
                                                        .join(", ")}
                                                </p>
                                            )}
                                        </div>
                                        <button
                                            onClick={() => {
                                                finalizeSelection();
                                                setProductModalOpen(false);
                                            }}
                                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium"
                                        >
                                            Add Products
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </form>

                {/* Customer Details Popup */}
                {isPopupVisible && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                            <div className="flex justify-between items-center border-b p-4">
                                <h2 className="text-xl font-bold text-gray-800">
                                    Customer Appointment History
                                </h2>
                                <button
                                    onClick={handleClosePopup}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <FaTimes size={24} />
                                </button>
                            </div>

                            <div className="p-4 overflow-y-auto flex-grow">
                                {customerData ? (
                                    <div className="overflow-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Name
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Mobile
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Time
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Date
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Services
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {customerData
                                                    .previous_appointments
                                                    ?.length > 0 ? (
                                                    customerData.previous_appointments.map(
                                                        (item, index) => (
                                                            <tr
                                                                key={index}
                                                                className={
                                                                    index %
                                                                        2 ===
                                                                    0
                                                                        ? "bg-white"
                                                                        : "bg-gray-50"
                                                                }
                                                            >
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                                                    {
                                                                        customerData.customer_name
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {
                                                                        customerData.customer_mobile_no
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {item.time}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                                                    {item.Date}
                                                                </td>
                                                                <td className="px-4 py-3 text-sm text-gray-500">
                                                                    {(() => {
                                                                        try {
                                                                            const services =
                                                                                JSON.parse(
                                                                                    item.services
                                                                                );
                                                                            return services.map(
                                                                                (
                                                                                    service,
                                                                                    idx
                                                                                ) => (
                                                                                    <div
                                                                                        key={
                                                                                            idx
                                                                                        }
                                                                                        className="mb-1 last:mb-0"
                                                                                    >
                                                                                        •{" "}
                                                                                        {
                                                                                            service.Description
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            );
                                                                        } catch (error) {
                                                                            return (
                                                                                <div>
                                                                                    {
                                                                                        item.services
                                                                                    }
                                                                                </div>
                                                                            );
                                                                        }
                                                                    })()}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan="5"
                                                            className="px-4 py-4 text-center text-sm text-gray-500"
                                                        >
                                                            No appointment
                                                            history found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="flex justify-center items-center h-32">
                                        <CircularProgress size={24} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewInquiry;
